import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const suspendedListApi = createAsyncThunk('co-users/listSuspended', async (_, { getState, rejectWithValue }) => {
  const { loginToken } = getState();
  const authToken = loginToken?.response?.token;
  try {
    const response = await fetch(
      `${ROOT_URL}/co-users/listSuspended`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const suspendedAgentlist = createSlice(
  {
    name: 'addGroup',
    initialState,
    reducers: {},
    extraReducers: {
      [suspendedListApi.pending]: (state) => ({
        ...state,
        isLoading: true,
      }),
      [suspendedListApi.fulfilled]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        response: action.payload,
      }),
      [suspendedListApi.rejected]: (state, action) => ({
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      }),
    },
  },
);

export default suspendedAgentlist;
